const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp'];

const normalizeMaybeUrl = (value: string): string => {
  // Strip common wrappers/punctuation without being overly aggressive
  return value
    .trim()
    .replace(/^<+/, '')
    .replace(/>+$/, '')
    .replace(/[),.;]+$/g, '');
};

const isImageUrl = (raw: string): boolean => {
  const cleaned = normalizeMaybeUrl(raw);
  if (!cleaned) return false;
  let url: URL;
  try {
    url = new URL(cleaned);
  } catch {
    return false;
  }

  const pathname = url.pathname.toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => pathname.endsWith(ext));
};

export const extractImageUrlsFromText = (text: string): string[] => {
  if (!text || !text.trim()) return [];

  // Agent Service image messages can be pipe-delimited: "url1|url2|..."
  const tokens = text.includes('|') ? text.split('|') : text.split(/\s+/g);

  const urls: string[] = [];
  for (const token of tokens) {
    const cleaned = normalizeMaybeUrl(token);
    if (!cleaned) continue;
    if (!isImageUrl(cleaned)) continue;
    urls.push(cleaned);
  }

  // Dedupe while preserving order
  return Array.from(new Set(urls));
};

export const isImageOnlyMessageText = (text: string, imageUrls: string[]): boolean => {
  if (!text || !text.trim()) return false;
  if (imageUrls.length === 0) return false;

  let remainder = text;
  for (const url of imageUrls) {
    remainder = remainder.split(url).join('');
  }

  // If after removing urls + separators there is no meaningful text, treat as image-only
  remainder = remainder.replace(/[|\s]+/g, '').trim();
  return remainder.length === 0;
};

export const shouldRenderMessageAsImages = (params: {
  text: string;
  messageType?: string | null | undefined;
}): { isImage: boolean; imageUrls: string[] } => {
  const imageUrls = extractImageUrlsFromText(params.text);
  const normalizedType = (params.messageType || '').toLowerCase();
  const isImageType = normalizedType === 'image';

  const isImageOnly = isImageOnlyMessageText(params.text, imageUrls);
  const isImage = (isImageType && imageUrls.length > 0) || isImageOnly;

  return { isImage, imageUrls };
};


